import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
// TODO Intégrer la logique de useFetch sur l'affichage d'erreur, etc.. ( d'une manière globale à toutes les api )
export const LocationGroupApi = createApi({
        reducerPath: 'locationGroupApi',
        baseQuery: fetchBaseQuery({baseUrl: process.env.REACT_APP_API_URI}),    // TODO Pas ouf
        endpoints: (builder) => ({
            getLocationGroupBySlug: builder.query({
                query: (slug) => `location_group_get/${slug}`,
            }),
        }),
    }
)

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetLocationGroupBySlugQuery} = LocationGroupApi